"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var TOGGLE_ENABLED_COUNT_FOR_PC = 25;
var TOGGLE_ENABLED_COUNT_FOR_SP = 10;
var BRAND_COUNT_ON_CLOSED_FOR_PC = 20;
var BRAND_COUNT_ON_CLOSED_FOR_SP = 10;
var BrandList = function (_a) {
    var brandList = _a.brandList, isSmartPhone = _a.isSmartPhone;
    var _b = react_1.default.useState(true), isClosed = _b[0], setClosed = _b[1];
    var toggleClose = function () {
        setClosed(!isClosed);
    };
    var toggleEnabledCount = isSmartPhone ? TOGGLE_ENABLED_COUNT_FOR_SP : TOGGLE_ENABLED_COUNT_FOR_PC;
    var toggleEnabled = brandList.length > toggleEnabledCount;
    var brandCountOnClosed = isSmartPhone ? BRAND_COUNT_ON_CLOSED_FOR_SP : BRAND_COUNT_ON_CLOSED_FOR_PC;
    var list = toggleEnabled && isClosed ? brandList.slice(0, brandCountOnClosed) : brandList;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("ul", { className: "categoryLp-Cases_OtherBrandList" }, list.map(function (brand, index) { return (react_1.default.createElement("li", { key: index },
            brand.link ? (react_1.default.createElement("a", { href: brand.link, className: "categoryLp-Cases_BrandLink" },
                react_1.default.createElement("span", null, brand.name))) : (react_1.default.createElement("span", null, brand.name)),
            brand.sub && react_1.default.createElement("small", null, brand.sub))); })),
        toggleEnabled &&
            react_1.default.createElement("div", { className: (0, classnames_1.default)('categoryLp-Cases_BrandListToggleButton', { 'categoryLp-Cases_BrandListToggleButton-close': isClosed }), onClick: toggleClose },
                react_1.default.createElement("div", { className: (0, classnames_1.default)('fa', isClosed ? 'fa-chevron-down down' : 'fa-chevron-up up') }))));
};
exports.default = BrandList;
